import { render } from "./QuantySuscriptoresChart.vue?vue&type=template&id=a548e488&scoped=true"
import script from "./QuantySuscriptoresChart.vue?vue&type=script&lang=js"
export * from "./QuantySuscriptoresChart.vue?vue&type=script&lang=js"

import "./QuantySuscriptoresChart.vue?vue&type=style&index=0&id=a548e488&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a548e488"]])

export default __exports__